import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "./pages/login";
import Codes from "./pages/settings/codes";
import Individual from "./pages/registration/individual";
import Corporate from "./pages/registration/corporate";
import TradersChannelPartner from "./pages/registration/traderschannelpartner";
import "./App.css";
import AuthenticationCode from "pages/authUtils/authenticationCode";
import ForgotPassword from "pages/authUtils/forgotPassword";
import ForgotPasswordReset from "pages/authUtils/forgotPasswordReset";
import ForgotPasswordNew from "pages/authUtils/forgotPasswordNew";
import Assets from "pages/asset/assets";
import BulkUpload from "pages/asset/bulkUpload";
import UpdateProfileDetails from "pages/profile/updateProfileDetails";
import Register from "pages/asset/register";
import EmailSettings from "pages/settings/emailSettings";
import ApiKeySettings from "pages/settings/apiKeySettings";
import CategorySettings from "pages/settings/categorySettings";
import EmailTemplateSettings from "pages/settings/emailTemplateSettings";
import MenuGroupSettings from "pages/settings/menuGroupSettings";
import PaymentAccountSettings from "pages/settings/paymentAccountSettings";
import RoleSettings from "pages/settings/roleSettings";
import SmsAccountSettings from "pages/settings/smsAccountSettings";
import SmsTemplateSettings from "pages/settings/smsTemplateSettings";
import TownCitySettings from "pages/settings/townCitySettings";
import OwnershipTypeSettings from "pages/settings/ownershipTypeSettings";
import RankSettings from "pages/settings/rankSettings";
import StationSettings from "pages/settings/stationSettings";
import ChangePassword from "pages/settings/changePassword";
import IndividualProfileView from "pages/profile/individual";
import CorporateProfileView from "pages/profile/corporate";
import Users from "pages/users";
import Insurance from "pages/registration/insurance";
import Lawenforcement from "pages/registration/lawenforcement";
import BillingTemplateSettings from "pages/settings/billingTemplateSettings";
import BundleSettings from "pages/settings/bundleSettings";
import PdfTemplateSettings from "pages/settings/pdfTemplateSettings";
import DocumentTypeSettings from "pages/settings/documentTypeSettings";
import { Account } from "pages/billing/Account";
import Dashboard from "pages/dashboard";
import UploadDocuments from "pages/profile/uploadDocuments";
import SearchAsset from "pages/asset/searchAsset";
import FlaggedItems from "pages/asset/flaggedItems";
import SearchAssetLaw from "pages/asset/searchAssetLaw";
import PublicAnnouncement from "pages/announcement/publicAnnouncement";
import MyAnnouncement from "pages/announcement/myAnnouncement";
import Reports from "pages/report/reports";
import ReportView from "pages/report/reportview";
import FlaggedItemsLaw from "pages/asset/flaggedItemsLaw";
// import PrepaidBilling from "pages/billing/prepaid";
// import PostpaidBilling from "pages/billing/postpaid";
import SubscriptionSettings from "pages/settings/subscriptionSettings";
import MyFlaggedItemsLaw from "pages/asset/flaggedItemsMyLaw";
import UpdatePopStatus from "pages/billing/updatePopStatus";

function App() {
  let url = "http://localhost:8082";
  if ((window.location + "").includes("asset.kimbahtech.com")) {
    url = "https://asset.kimbahtech.com";
  }
  localStorage.setItem("assethost", url + "/assetregister");
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/registration/individual" element={<Individual />} />
          <Route path="/registration/corporate" element={<Corporate />} />
          <Route
            path="/registration/traders-channel-partner"
            element={<TradersChannelPartner />}
          />
          <Route path="/registration/insurance" element={<Insurance />} />
          <Route
            path="/registration/lawenforcement"
            element={<Lawenforcement />}
          />

          <Route path="/auth/code" element={<AuthenticationCode />} />
          <Route path="/auth/forgot" element={<ForgotPassword />} />
          <Route path="/auth/forgot/reset" element={<ForgotPasswordReset />} />
          <Route path="/auth/forgot/new" element={<ForgotPasswordNew />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/setting/codes"
            element={
              <PrivateRoute>
                <Codes />
              </PrivateRoute>
            }
          />
          <Route path="/settings/email-account" element={<EmailSettings />} />
          <Route path="/settings/api-key" element={<ApiKeySettings />} />
          <Route path="/settings/category" element={<CategorySettings />} />
          <Route
            path="/settings/email-template"
            element={<EmailTemplateSettings />}
          />
          <Route path="/settings/menu-group" element={<MenuGroupSettings />} />
          <Route
            path="/settings/payment-account"
            element={<PaymentAccountSettings />}
          />
          <Route path="/settings/role" element={<RoleSettings />} />
          <Route
            path="/settings/sms-account"
            element={<SmsAccountSettings />}
          />
          <Route
            path="/settings/sms-template"
            element={<SmsTemplateSettings />}
          />
          <Route
            path="/settings/change-password"
            element={<ChangePassword />}
          />
          <Route path="/settings/town-city" element={<TownCitySettings />} />
          <Route
            path="/settings/ownership-type"
            element={<OwnershipTypeSettings />}
          />
          <Route path="/settings/rank" element={<RankSettings />} />
          <Route path="/settings/station" element={<StationSettings />} />
          <Route
            path="/settings/pdf-template"
            element={<PdfTemplateSettings />}
          />
          <Route
            path="/settings/document-type"
            element={<DocumentTypeSettings />}
          />
          <Route
            path="/settings/subscription"
            element={<SubscriptionSettings />}
          />

          <Route path="/asset/assets" element={<Assets />} />
          <Route path="/asset/bulk-upload" element={<BulkUpload />} />
          <Route path="/asset/register" element={<Register />} />
          <Route path="/asset/search" element={<SearchAsset />} />
          <Route path="/asset/search/law" element={<SearchAssetLaw />} />
          <Route path="/asset/flagged" element={<FlaggedItems />} />
          <Route path="/asset/flagged/law" element={<FlaggedItemsLaw />} />
          <Route path="/asset/myflagged/law" element={<MyFlaggedItemsLaw />} />
          <Route
            path="/asset/public-announcement"
            element={<PublicAnnouncement />}
          />
          <Route path="/asset/my-announcement" element={<MyAnnouncement />} />

          <Route
            path="/update-profile-details"
            element={<UpdateProfileDetails />}
          />
          <Route path="/upload-documents" element={<UploadDocuments />} />

          <Route
            path="profile/individual"
            element={<IndividualProfileView />}
          />
          <Route path="profile/corporate" element={<CorporateProfileView />} />

          <Route
            path="/billing/billing-template"
            element={<BillingTemplateSettings />}
          />
          <Route path="/billing/bundle" element={<BundleSettings />} />
          <Route path="/billing/account" element={<Account />} />
          {/* <Route path="/billing/prepaid" element={<PrepaidBilling />} />
          <Route path="/billing/postpaid" element={<PostpaidBilling />} /> */}
          <Route
            path="/billing/update-pop-status"
            element={<UpdatePopStatus />}
          />

          <Route path="/users" element={<Users />} />

          <Route path="/report/manager" element={<Reports />} />
          <Route path="/report/view" element={<ReportView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
